<template>
  <!-- <div class="card-form">
    <EditForm ref="editForm" :disabled="disabled" :amzAppCode="amzAppCode" />
  </div> -->

  <div>
    <el-card>
      <EditForm
        ref="editForm"
        :disabled="disabled"
        :amzAppCode="amzAppCode"
        @loaded="(d) => (baseInfo = d)"
      />
      <div class="d-flex justify-content-between align-items-center mt-2">
        <div>
          <el-tag
            size="mini"
            :type="baseInfo.appStatus === 'N' ? 'danger' : 'success'"
          >
            {{ baseInfo.v_appStatus || 'New' }}
          </el-tag>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            Create：{{ baseInfo.createByName || '--' }} at
            {{ baseInfo.createTime || '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            Modify：{{ baseInfo.modifyByName || '--' }} at
            {{ baseInfo.modifyTime || '--' }}
          </span>
        </div>
        <div>
          <el-button
            v-if="!disabled"
            type="primary"
            size="small"
            @click="$refs.editForm.save()"
          >
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </div>
    </el-card>
    <el-card class="mt-4" v-if="amzAppCode">
      <AccountTable :disabled="disabled" :amzAppCode="amzAppCode" />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import AccountTable from '../components/account-table'
export default {
  name: 'ecom-sys-amzApp-detail',
  components: { EditForm, AccountTable },
  data() {
    return { baseInfo: {} }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    amzAppCode() {
      return this.params.amzAppCode
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
}
</style>
